<script setup>
  import { computed } from 'vue';
  import TeaserItem from '@/components/Ui/TeaserItem.vue';

  const props = defineProps({
    textLeft: String,
    items: String
  })

  const items = computed(() => {
    if (!props.items) return false
    return JSON.parse(props.items)
  })

</script>

<template>
  <section
    class="element-teaser-row ~mt-20/28 max-w-screen-2xl mx-auto px-6"
  >
    <GridLayout>
      <LeftHeadline
        :text="textLeft"
      />
      <div
        class="element-teaser-row-items grid grid-cols-1 lg:grid-cols-3 lg:gap-14 lg:col-span-8"
      >
        <TeaserItem
          v-for="(item, index) in items"
          :key="index"
          :item="item"
        />
      </div>
    </GridLayout>
  </section>
</template>

<style lang="scss" scoped>

</style>
